import { useQuery } from "@tanstack/react-query";

import input from "../../../../assets/styles/components/input.module.css";
import { getCostCenters } from "../../../../services/cashFlow";

interface SelectCostCenterProps {
    handleChangeCostCenter: (e: string) => void;
    value: string;
    disabled?: boolean;
}

const SelectCostCenter = ({ handleChangeCostCenter, value, disabled }: SelectCostCenterProps) => {
    const { data, isLoading } = useQuery({
        queryKey: ["getCostCenters"],
        queryFn: () => getCostCenters(),
        staleTime: 1000 * 60 * 5,
    });

    const handleChange = (e: string) => {
        handleChangeCostCenter(e);
    };

    return (
        <label>
            Centro de Custo
            <select
                className={input.input}
                value={value}
                onChange={(e) => handleChange(e.target.value)}
                disabled={isLoading || disabled}
                data-readonly={disabled}
            >
                <option defaultValue="">{
                    isLoading
                        ? "Carregando..."
                        : !disabled
                            ? "Selecione"
                            : "-"
                }</option>
                {data &&
                    Object.values(data).length > 0 &&
                    data.map((c: { uid_centro_custo: string; nome: string }) => (
                        <option value={c.uid_centro_custo} key={c.uid_centro_custo}>
                            {c.nome}
                        </option>
                    ))}
            </select>
        </label>
    );
};

export default SelectCostCenter;